<template>
  <div id="loader">
    <sidebar-right-side :uploadEndpoint="uploadEndpoint" :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar" :data="sidebarData" :fieldStructure="dataStructure" :key="operation + formType"
      :endPoint="endPoint" :addionalData="filter" @addNew="(value) => addNew(value)" />

    <vs-popup fullscreen title="Info" :active.sync="showPopupInfo">
      <show-info :key="curentRowId" />
    </vs-popup>

    <vs-popup title="QR Code" :active.sync="showQRCode" class="text-center" style="align-items: center;">
      <VueQRCodeComponent class="bg-white p-1" error-level="L" :text="selectedQrCode" :size="550" />
    </vs-popup>

    <vs-popup fullscreen title="PDF Preview" :active.sync="showPdf">
      <vue-pdf :key="updateUrl" :sourceFile="updateUrl" />
    </vs-popup>

    <vs-popup fullscreen title="Image Preview" :active.sync="showImage">
      <div class="centerx"></div>
      <img :src="updateImageUrl" :sourceFile="updateImageUrl" />
    </vs-popup>
    <search :endPoint="endPoint" v-if="dataStatructureReady" @submit="(data) => filterHandler(data)"
      @print="(data) => printHandler(data)" />


    <div>
      <vs-pagination :total="pageTotal" v-model="currentx" goto></vs-pagination>
    </div>

    <!-- <pdfViewer v-if="pdfUrl" :pdfUrl="pdfUrl" /> -->


  </div>
</template>

<script>
import axios from "@/axios.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

//form type
import sidebarRightSide from "../dataViews/sidebarRightSide";
import profile from "../dataViews/profile";
// import popup from "../dataViews/displayOptions/popup_fullscreen.vue";

import selectable from "../table/selectable.vue";

import { alertMixin } from "../../../mixin/alertMixin";
import { axiosMixin } from "../../../mixin/axiosMixin";
import { helperMixin } from "../../../mixin/helperMixin";
import { mapGetters } from "vuex";
import VueQRCodeComponent from 'vue-qrcode-component'
import vuePdf from "../dataViews/vuepdf";
import search from "./searchMiscell";
import showInfo from "./showPopupInfo";
import pdfViewer from "./pdfViewer";
export default {
  mixins: [alertMixin, axiosMixin, helperMixin],
  components: {
    sidebarRightSide,
    profile,
    selectable,
    vuePdf,
    search,
    showInfo,
    VueQRCodeComponent,
    pdfViewer
  },
  props: {
    endPoint: {
      type: String
    },
    uploadEndpoint: {
      type: String
    },
    formType: {
      type: String
    },
    filter: {
      type: Object,
      default() {
        return {};
      }
    },
    filterEndpoint: {
      type: String,
      default: ""
    },
    viewOnly: {
      type: Boolean
    },
    showAddBtn: {
      type: Boolean,
      default: true
    },
    showEditBtn: {
      type: Boolean,
      default: true
    },
    showActionButton: {
      type: Boolean,
      default: true
    },
    showCancelBtn: {
      type: Boolean,
      default: true
    },
    editPage: {
      type: String,
      default: ""
    },
    previewPage: {
      type: String,
      default: ""
    }
  },
  filters: {
    toUpperCase(value) {
      return value.toUpperCase();
    },
  },
  data: () => ({
    showPopupInfo: false, //show details popup
    curentRowId: "", //this is use so that we can trigger a reload to show a popup for row info
    numPages: 3, //total number of pages for pdf preview
    thePdfSource: "", //use to display the PDF
    theImageSource: "", //use to display the IMAGES
    showPopup: false, //this is a form type. if true, the popup will show
    showPdf: false, //use for displaying files from table
    showImage: false, //use for displaying files from table
    operation: "add",
    dataStructure: {},
    tblData: [],
    selected: [],
    log: [],
    currentx: 1,
    pageTotal: 1,
    per_page: 10,
    sort_by: "id",
    sort_direction: "desc",
    totalData: 0,
    isMounted: false,
    //for sidebar form
    addNewDataSidebar: false,
    sidebarData: {},
    dataStatructureReady: false,
    breadcrumb: [],
    selectedQrCode: "",
    showQRCode: false,
    pdfUrl: ''
  }),

  computed: {
    ...mapGetters({
      getProfileId: "profile/getProfileId",
      getMainInfo: "profile/getMainInfo",
      getUserInfo: "auth/getUserInfo",
    }),
    baseURl() {
      return axios.defaults.baseURL;
    },
    currentPage() {
      if (this.isMounted) {
        return this.currentx;
      }
      return 0;
    },
    tableComputedData() {
      return this.tblData;
    },
    showAdd() {
      return !this.viewOnly;
    },
    updateUrl() {
      return this.thePdfSource;
    },
    updateImageUrl() {
      return this.theImageSource;
    }
  },
  watch: {

    '$route.meta.breadcrumb': function (newBreadcrumb) {
      // Update the component's breadcrumb property
      this.breadcrumb = newBreadcrumb;
    },
    currentx: function () {
      this.getData("from current x");
    },
    per_page: function () {
      this.getData("from perpage");
    }
  },
  methods: {
    activateQrCode(selectedQrCode) {
      this.selectedQrCode = selectedQrCode;
      this.showQRCode = true;
    },
    checkFiles(files) {
      return files.split(",");
    },
    imgSrc(src) {
      return this.baseURl + "/storage/" + src;
    },
    pdfImg(src) {
      return this.baseURl + "/storage/pdf.png";
    },
    addThousdanOperator(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    checkExtention(source) {
      return this.getFileExtention(source);
    },
    showFileOrImageHandler(source) {
      console.log("source: ", source);
      var theSource = source.split(",");
      console.log("theSource.length:", theSource.length);
      this.currentImages = [];

      var filename = this.getFileExtention(source);
      console.log("filename:", filename);
      if (filename == "pdf") {
        this.showPdf = true;
        this.thePdfSource = this.baseURl + "/storage/" + source;
      } else if (
        filename == "jpeg" ||
        filename == "jpg" ||
        filename == "png" ||
        filename == "gif"
      ) {
        this.theImageSource = this.baseURl + "/storage/" + source;
        this.showImage = true;
      }
      else {
        console.log("sourceaaa; ", source)
        this.theImageSource = this.baseURl + "/storage/" + source;
        this.showImage = true;
      }

    },

    returnFilters() {
      return {
        pkId: this.getMainInfo.prVendorId
      };
    },
    startLoading() {
      this.$vs.loading({
        container: "#loader",
        scale: 0.6
      });
    },
    closeLoading() {
      this.$vs.loading.close("#loader > .con-vs-loading");
    },
    decodeSelectValue(tr, td, options) {
      return this.decodeValueForSelect(options, this.tblData[tr][td]);
    },
    // decodeSelectValue(value,options) {
    //  return this.arrayOfObjectFind(options,value)[0].label;
    // },
    decodeMultiSelectValue(tr, td) {
      return this.flattenJsonStringArray(this.tblData[tr][td], "label");
    },
    addNew($val) {
      if (this.sort_direction == "asc") {
        var newTotalPage = Math.ceil((this.totalData + 1) / this.per_page);
        if (this.currentx != newTotalPage) {
          this.currentx = newTotalPage;
        } else {
          this.getData("add new");
        }
      } else {
        if (this.currentx == this.pageTotal) {
          this.getData("add new");
        } else {
          this.currentx = this.pageTotal;
        }
      }
    },
    filterHandler(data) {
      console.log("search:", data);

      this.filterData = data;
      this.addToObject(this.filter, {
        advanceFilter: this.filterData
      });
      // this.getData("advance filter");
      this.printNow();
    },
    printHandler(data) {
      console.log("print:", data);

      this.filterData = data;
      this.addToObject(this.filter, {
        advanceFilter: this.filterData
      });
      this.printNow();
    },
    printNow() {
      this.startLoading();
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction + "&user=" + this.getUserInfo.name;

      this.startLoading();;
      this.aronPost('printMiscellReport', this.filter, params, sort)
        .then(response => {
          if (response.status == 200) {
            window.open(response.data.url, "_blank");
            //this.pdfUrl = response.data.url;
          }

          this.closeLoading();
        })
        .catch(error => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading();
        });

    },

    deleteData(data) {
      this.aronDelete(this.endPoint, data.id, "Item Deleted!")
        .then(response => {
          if (this.countObject(this.tblData) <= 0) {
            this.currentx = this.currentx - 1;
            if (this.currentx < 0) {
              this.currentx = 0;
            }
          } else {
            this.getData("delete");
          }
        })
        .catch(error => {
          console.log("in elete error: ", error);
        });
    },
    handleSort(key, direction) {
      this.sort_by = key;
      this.sort_direction = direction;
      this.getData("from sort");
    },
    handleClick(type, index) {
      //console.log(this.tblData[index]);
    },
    insertDone(val) {
      this.showPopup = false;
      this.getData("insert");
    },
    handleSelected(tr) {
      this.curentRowId = tr.id;
      this.$store.dispatch("profile/setCurrentMainInfo", tr);
      this.$store.dispatch(
        "profile/setCurrentMainDataStructure",
        this.dataStructure
      );
      //this.showPopupInfo = true;
      //emit to parent
      this.$emit("selected", tr);
    },
    getData(from) {
      this.startLoading();
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction;
      if (this.countObject(this.filter) > 0) {
        console.log("filterEndpoint:", this.filterEndpoint);
        this.aronPost(this.filterEndpoint, this.filter, params, sort)
          .then(response => {
            if (response.status == 200) {
              this.tblData = response.data.data;
              this.dataStructure = response.data.fields;

              this.setDataStructure();
              this.dataStatructureReady = true;

              this.totalData = response.data.meta.pagination.total;
              this.pageTotal = response.data.meta.pagination.total_pages;
            }

            this.closeLoading();
          })
          .catch(error => {
            // this.decodeErrorFromAxios(error);
            this.closeLoading();
          });
      } else {
        this.aronGet(this.endPoint, params, sort)
          .then(response => {
            this.tblData = response.data.data;
            this.dataStructure = response.data.fields;

            this.setDataStructure();
            this.dataStatructureReady = true;

            this.pageTotal = response.data.meta.pagination.total_pages;
            this.totalData = response.data.meta.pagination.total;

            this.closeLoading();
          })
          .catch(error => {
            // this.decodeErrorFromAxios(error);
            this.closeLoading();
          });
      }
    },
    setDataStructure() {
      this.$store.dispatch("profile/setMainDataStructure", this.dataStructure);
    },
    editData(data) {
      //change the operation to update
      this.operation = "update";
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    addNewData() {
      if (this.formType == "sidebarRightSide") {
        this.sidebarData = {};
        this.toggleDataSidebar(true);
      } else if (this.formType == "profile") {
        this.$store.dispatch("profile/setMainInfo", {});
        this.$store.dispatch(
          "profile/setMainDataStructure",
          this.dataStructure
        );

        this.$router
          .push("/edit/" + this.endPoint + "/" + "new")
          .catch(() => { });
      } else if (this.formType == "popup") {
        this.showPopup = true;
      } else {
        this.$store.dispatch("profile/setMainInfo", {});
        this.$store.dispatch(
          "profile/setMainDataStructure",
          this.dataStructure
        );

        this.$router
          .push("/" + this.editPage + "/" + this.endPoint)
          .catch(() => { });
      }
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    }
  },
  created() {
    this.dataStatructureReady = false;
  },
  mounted() {
    this.isMounted = true;
    this.getData("created");
  }
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
